import 'globalthis/auto';

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes recent versions of Safari, Chrome (including
 * Opera), Edge on the desktop, and iOS and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';

// Disable $localize warnings for missing translations by providing a noop handler.
// See: https://angular.io/guide/i18n-common-setup#missing-translations
// This must be set after @angular/localize/init so that $localize exists and before the app bootstraps.
(function setMissingTranslationHandler() {
  function getGlobal(): any {
    if (typeof window !== 'undefined') return window as any;
    if (typeof self !== 'undefined') return self as any;
    return {} as any;
  }
  try {
    const g: any = getGlobal();
    if (g?.$localize) {
      // If Angular runtime attempts to report a missing translation, ignore it silently.
      // Supported values are a function or string token like 'ignore'. We use a function for broad compatibility.
      g.$localize.missingTranslation = () => {
        // no-op: swallow missing translation warnings
        return undefined as any;
      };
      // For older versions that accept string tokens, set to 'ignore' as well (harmless if unsupported).
      try {
        g.$localize.missingTranslation =
          g.$localize.missingTranslation || 'ignore';
      } catch (e) {
        // ignore
      }
    }
  } catch (e) {
    // ignore
  }
})();

// Suppress Angular $localize console warnings when a translation key is missing.
// Angular 17 may still emit console.warn messages like "No translation found for ..." even when
// $localize.missingTranslation is set. Filter only those specific warnings to avoid log spam.
(function suppressLocalizeConsoleWarnings() {
  try {
    const originalWarn = console.warn.bind(console);
    console.warn = (...args: any[]) => {
      try {
        const first = args?.length ? args[0] : '';
        if (
          typeof first === 'string' &&
          (first.startsWith('No translation found for') ||
            first.startsWith('Missing translation for'))
        ) {
          return; // swallow i18n missing translation warnings only
        }
      } catch {
        // fall through to original warn
      }
      originalWarn(...args);
    };
  } catch {
    // ignore
  }
})();
